module.exports = __webpack_public_path__ + "7a40a574221b1ee58e2916b2f22b9397.svg";